import React from 'react';
import { fromPairs, map, get, isEmpty, isEqual, filter, find } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { popover } from 'modules/popover';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { addEditAddressForm as AddEditAddressForm } from 'ui/views/widgets/addEditAddressForm';
 *
 * // render
 * <AddEditAddressForm propName='propValue'/>
 */
export const addCreditOverlay = ( props ) => {

    const { actions } = props;

    // selection mode data
    const { addressSelectionConfig, addressOptions, selected = {} } = props;

    return (
        <div className='ui-add-credit-form'>

            <div className='ui-add-credit-form__header'>

                {/* title for the modal */}
                <div className='ui-add-credit-form__header__title'>
                   Add Credit
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-add-credit-form__body'>

                {/* selection mode */}
                { 'selection' === props.mode ?  (
                    <div className='ui-add-credit-form__body__selection'>

                        <div className='ui-add-credit-form__body__selection__message'>
                            { getLabel( addressSelectionConfig.description.title ) }
                        </div>
                    </div>

                ): (

                    <Form
                        fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                        values={ props.itemData } // default values
                        isValid={ false }
                        mode={ props.mode }
                        onSubmit={ ( { values, isValid } ) => {
                            if( isValid ) {
                                props.onFormSubmit( {
                                    ...values
                                } );
                                popover.close();
                                props.onCancelClick();
                            }
                        } }
                    >
                        { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                            return (
                                <form
                                    onSubmit={ onSumbit }
                                    className='ui-add-credit-form__body__form'
                                >
                                    { /* fields */ }
                                    { map( fields, ( field ) => {

                                        const fieldClassName = classnames( 'ui-add-credit-form__body__form__field', `ui-add-credit-form__body__form__${field.name}` );
                                        
                                        return (
                                            <field.view
                                                className={ fieldClassName }
                                                key={ field.name }
                                                name={ field.name }
                                                required={ field.required }
                                                placeholder={ field.placeholder }
                                                label={ field.title }
                                                onChange={ (data) => {
                                                    if ( data?.name === 'paymentAmount' && (isNaN(data?.value) || ( data?.value?.indexOf(".") && data?.value?.toString().split('.')[1]?.length > 2 ) ) ) {
                                                        return;
                                                    }
                                                    onChange(data);
                                                 } }
                                                value={ values[ field.name ] }
                                                error={ errors[ field.name ] }
                                                options={ get( props.values.options, field.options ) }
                                                allowFilter={ 'state' === field.name }
                                                config={ field.config }
                                            />
                                        );
                                    } ) }

                                    {/* button actions */}
                                    <div className='ui-add-credit-form__body__form__actions'>
                                        { map( actions, action => {
                                            return (
                                                <Button
                                                    key={ action.name }
                                                    id= { action.name }
                                                    type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                    disabled={ 'cancel' !== action.name ? !isValid : false }
                                                    { ...action }
                                                    outline={ 'cancel' === action.name ? true: false }
                                                    size='medium'
                                                    className='ui-add-credit-form__body__form__actions__action'
                                                    onClick = { isEqual( 'cancel', action.name ) ?  () => {
                                                        popover.close();
                                                        props.onCancelClick();} : null }
                                                />
                                            );
                                        } ) }
                                    </div>
                                </form>
                            );
                        } }
                    </Form>
                ) }
				
			</div>
        </div>
    );
};

// set display name
addCreditOverlay.displayName = 'addCreditOverlay';

// set default props
addCreditOverlay.defaultProps = {};

// prop types
addCreditOverlay.propTypes = {};
